import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectNotificationDetailsForId } from 'app/store/notifications';
import { NotificationDetails } from './NotificationDetails.jsx';

const mapStateToProps = createStructuredSelector({
    message: selectNotificationDetailsForId
});

export const NotificationDetailsContainer = connect(mapStateToProps)(NotificationDetails);
